import { render } from "./ExternalFooter.vue?vue&type=template&id=0390a149"
import script from "./ExternalFooter.vue?vue&type=script&lang=js"
export * from "./ExternalFooter.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__